// extracted by mini-css-extract-plugin
module.exports = {"previous":"PrevButton_previous__1TDjI","previousLink":"PrevButton_previousLink__3RfVF"};